import { apiOfficialClient } from './config.js';
import { apiClientPbx } from '@/api/sipmovil_auth_api.js'

export default {
  getTemplates(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`templates/`);
  },
  getTemplatesPbxImages(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientPbx.get(`api/whatsapp/whatsapp_templates/?search=image`);
  },
  getTemplatesPbxVideos(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientPbx.get(`api/whatsapp/whatsapp_templates/?search=video`);
  },
  getDefaultMessages(token, admin, isAdmin) {
    apiClientPbx.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientPbx.get(
      `api/whatsapp/default-messages/?admin=${admin}&isAdmin=${isAdmin}`
    );
  },
  getVariablesTemplates(token, templateId) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientPbx.get(`api/whatsapp/get-default-template-values/?template_id=${templateId}`);
  },
  updateVariablesTemplates(token, data) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientPbx.post(`api/whatsapp/default-template-values/`, data);
  },
};
